import '../styles/Process.css';

const steps = [
  {
    num: '01',
    title: 'Ücretsiz Analiz',
    desc: 'Mevcut sosyal medya hesaplarınızı, rakiplerinizi ve sektörünüzü derinlemesine analiz edip fırsatları tespit ediyoruz.',
  },
  {
    num: '02',
    title: 'Strateji Geliştirme',
    desc: 'Markanıza özel içerik takvimi, hedef kitle segmentasyonu ve reklam stratejisi hazırlıyoruz.',
  },
  {
    num: '03',
    title: 'Uygulama & Optimizasyon',
    desc: 'Kampanyaları başlatıyor, günlük takip ve optimizasyonlarla performansı sürekli artırıyoruz.',
  },
  {
    num: '04',
    title: 'Raporlama & Büyüme',
    desc: 'Aylık kapsamlı raporlar ve yeni büyüme planlarıyla sonuçlarınızı şeffaf şekilde paylaşıyoruz.',
  },
];

const metrics = [
  { val: '+142%', name: 'Organik Büyüme' },
  { val: '4.8x',  name: 'ROAS Ortalaması' },
  { val: '₺0.42', name: 'Tık Başına Maliyet' },
  { val: '12.4%', name: 'Etkileşim Oranı' },
];

const bars = [
  { label: 'Instagram', pct: 84 },
  { label: 'TikTok',    pct: 67 },
  { label: 'Facebook',  pct: 52 },
  { label: 'LinkedIn',  pct: 38 },
];

export default function Process() {
  return (
    <section className="process" id="nasil-calisir">
      <div className="process__left">
        <span className="label">Sürecimiz</span>
        <h2 className="section-title" style={{ marginBottom: '2.8rem' }}>
          4 Adımda<br />Başarıya Ulaşın
        </h2>
        <ol className="process__steps">
          {steps.map(s => (
            <li key={s.num} className="process__step">
              <span className="process__step-num">{s.num}</span>
              <div>
                <h3 className="process__step-title">{s.title}</h3>
                <p className="process__step-desc">{s.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>

      <div className="process__right">
        {/* Dashboard mockup */}
        <div className="dashboard">
          <div className="dashboard__bar">
            <span className="dashboard__dot" style={{ background: '#ff5f57' }} />
            <span className="dashboard__dot" style={{ background: '#febc2e' }} />
            <span className="dashboard__dot" style={{ background: '#28c840' }} />
            <span className="dashboard__title">Kampanya Paneli</span>
            <span className="dashboard__live">
              <span className="dashboard__live-dot" /> Canlı
            </span>
          </div>

          <p className="dashboard__section-label">Platform Erişim Dağılımı</p>

          <div className="dashboard__bars">
            {bars.map(b => (
              <div key={b.label} className="dashboard__bar-row">
                <span className="dashboard__bar-label">{b.label}</span>
                <div className="dashboard__bar-bg">
                  <div
                    className="dashboard__bar-fill"
                    style={{ width: `${b.pct}%` }}
                  />
                </div>
                <span className="dashboard__bar-val">{b.pct}%</span>
              </div>
            ))}
          </div>

          <div className="dashboard__kpis">
            {metrics.map(m => (
              <div key={m.name} className="dashboard__kpi">
                <span className="dashboard__kpi-val">{m.val}</span>
                <span className="dashboard__kpi-name">{m.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
